import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cscontinue(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free JavaScript Continue Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript Continue tutorial for beginners When a Javascript Continue is encountered inside any loop, control automatically passes to the first statement after the loop" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript Continue,Javascript Continue for,Javascript Continue for loop,Javascript foreach Continue" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-continue" />
 </Helmet>
 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Javascript Continue</h1>
    <div className="first">
        <a href="/javascript-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

<p className="mt-4 para">A Javascript continue usually associated with an if
</p>


<h2 className="headings">The Syntax for continuing in Javascript:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-3">&#123; </span>
  {"\n"}
          <span className="qwerty-10">&nbsp;Continue; </span>          
          {"\n"}
          <span className="qwerty-3">&#125; </span>
          {"\n"} {"\n"}
    
       
        </code>
      </pre>        
    </div>

<h2 className="mt-4 mh2">How to use Continue in Javascript:</h2>




<h2 className="headings">Q-Write a program loop starts from 1 to 10 and continues on four and print string before continuing example in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
          {"\n"}
          <span className="qwerty-3">&nbsp;var </span>
    <span className="qwerty-4">a;</span>
          {"\n"}
         
  <span className="qwerty-10">&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">a</span>
  <span className="qwerty">=</span>
  <span className="qwerty-1">2;</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty">&#60;=</span>
  <span className="qwerty-1">14;</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty">==</span> 
        <span className="qwerty-1">5</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">This is Continue</span> 
        <span className="qwerty-3">"</span> 
    
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;continue;</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 

      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#125; </span>
  {"\n"}
  {"\n"}

 


 

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
     </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
      
          <span className="qwerty-3">&nbsp;2 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;3 </span>          
          {"\n"}
         
          <span className="qwerty-3">&nbsp;4 </span>          
          {"\n"}
          <span className="qwerty-10">&nbsp;This is Continue </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;6 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;7 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;8 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;9 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;10 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;11 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;12 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;13 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;14 </span>          
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>





<h2 className="headings">Q-Write a program loop starts from 1 to 10 and continues on six examples in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
          {"\n"}
          <span className="qwerty-3">&nbsp;var </span>
    <span className="qwerty-4">a;</span>
          {"\n"}
         
  <span className="qwerty-10">&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">a</span>
  <span className="qwerty">=</span>
  <span className="qwerty-1">2;</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty">&#60;=</span>
  <span className="qwerty-1">14;</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty">==</span> 
        <span className="qwerty-1">6</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span> 
        <span className="qwerty">+</span> 
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Write Before Continue</span> 
        <span className="qwerty-3">"</span> 

      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;continue;</span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span> 
        <span className="qwerty">+</span> 
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">Not Write after Continue</span> 
        <span className="qwerty-3">"</span> 

      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#125; </span>
  {"\n"}
  {"\n"}

 


 

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;6</span> 
          <span className="qwerty-5">&nbsp;Write Before Continue </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;15</span> 
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Write a program loop starts from 1 to 10 and continue on 4 and 8 and Print String example in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
           
          {"\n"}
          <span className="qwerty-3">&nbsp;var </span>
    <span className="qwerty-4">a;</span>
          {"\n"}
         
  <span className="qwerty-10">&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">a</span>
  <span className="qwerty">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty">&#60;=</span>
  <span className="qwerty-1">10;</span>
  <span className="qwerty-4">a</span>
  <span className="qwerty">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty">==</span> 
        <span className="qwerty-1">4</span>
        <span className="qwerty"> || </span> 
        <span className="qwerty-4">a</span> 
        <span className="qwerty">==</span> 
        <span className="qwerty-1">8</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-3">"</span> 
        <span className="qwerty-8">This is Continue</span> 
        <span className="qwerty-3">"</span> 
  
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;continue;</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
    
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&#125; </span>
  {"\n"}
  {"\n"}

 


 

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
     
      
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;1 </span>          
          {"\n"} 
          <span className="qwerty-3">&nbsp;2 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;3 </span>          
          {"\n"}
          <span className="qwerty-10">&nbsp;This is Continue </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;5 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;6 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;7 </span>          
          {"\n"}
          <span className="qwerty-5">&nbsp;This is Continue </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;9 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;10 </span>          
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>


  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/javascript-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Cscontinue;